import { TextField } from "@mui/material";
import { styled } from "@mui/styles";
import { useField } from "formik";

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#C7DFE9",
    fontSize: 12,
  },
  "& label": {
    color: "#64748B",
    fontSize: 12,
  },
  "& input": {
    color: "#64748B",
    fontSize: 12,
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#C7DFE9",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#64748B",
    },
    "&:hover fieldset": {
      borderColor: "#C7DFE9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#C7DFE9",
    },
    "&:after fieldset": {
      borderColor: "#C7DFE9",
    },
  },
});

function TextAreaField({
  attribute: { label, name, type, onChange, disabled, width },
}) {
  const [field, meta] = useField(name);

  return (
    <div className={`flex ${width}`}>
      <CssTextField
        {...field}
        error={!!meta.error}
        helperText={meta.error}
        type={type}
        label={label}
        name={name}
        variant="outlined"
        fullWidth
        disabled={disabled}
        multiline
        rows={2}
        maxRows={4}
        InputLabelProps={{
          shrink: true,
        }}
      />
    </div>
  );
}

export default TextAreaField;
